import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/About.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/CursorRevealLazy.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/components/DesignArchive.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/components/Experience.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/IntroLoader.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/components/Projects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/StaggeredFadeSections.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/components/Writing.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
